import React from 'react';
import { Leaf, ChefHat } from 'lucide-react';
import '../../styles/HeroSection.css';

const HeroSection = ({ data, scrollY }) => {
  return (
    <section className="hero-section">
      <div className="hero-background" style={{
        transform: `translateY(${scrollY * 0.5}px)`
      }}>
        <div className="hero-overlay"></div>
      </div>
      
      <div className="hero-content">
        <div className="hero-profile">
          <img 
            src={data.profileImage} 
            alt={data.name}
            className="profile-image"
            style={{
              transform: `translateY(${scrollY * -0.3}px)`
            }}
          />
        </div>
        
        <div className="hero-text">
          <h1 className="hero-name">{data.name}</h1>
          <h2 className="hero-title">
            <ChefHat className="title-icon" />
            {data.title}
            <Leaf className="title-icon" />
          </h2>
          <p className="hero-subtitle">{data.subtitle}</p>
        </div>
      </div>
      
      <div className="hero-scroll-indicator">
        <div className="scroll-arrow"></div>
      </div>
    </section>
  );
};

export default HeroSection;